
import {
  BadRequestError,
  NetworkError,
  NotfoundError,
  ValidationError,
  UnauthorizedError,
  LockedError,
} from '@package/errors';
import { UUID, Events } from '@package/utils';

import qs from 'qs';
import axios from 'axios';


const defaultOptions = {
  method: 'get',
  url: '/',
  responseType: 'json',
};

let hostApi = null;
let state = null;
let dispatch = null;


export const events = new Events();


export const middleware = (options) => (store) => (next) => (action) => {

  hostApi = options['host'];
  state = store;
  dispatch = store['dispatch'];

  return next(action);
};

const request = async (options) => {
  try {
    options = {
      ...defaultOptions,
      ...options,
    };

    let headers = {
      'x-mc-correlation-id': UUID(),
    };

    if (options['headers']) {
      headers = {
        ...headers,
        ...options['headers'],
      };
    }

    if ( !! window.localStorage.getItem('merchantId')) {
      headers['x-mc-merchant-id'] = window.localStorage.getItem('merchantId');
    }

    const instance = axios.create({
      baseURL: hostApi,
      timeout: 24000,
      headers: headers,
      withCredentials: true,
      responseType: options['responseType'],
    });

    instance.interceptors.request.use(function (config) {
      config.paramsSerializer = (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
      return config;
    });

    const { data } = await instance(options);

    return data;
  }
  catch(error) {

    if (axios.isCancel(error)) {
      events.emit('cancel', error);
      return { success: true, data: null };
    }

    if (error['response']) {
      let { status, data } = error['response'];

      if (options['responseType'] === 'blob') {
        data = await new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            resolve(JSON.parse(reader['result']));
          };
          reader.onerror = () => {
            reject(error);
          };
          reader.readAsText(error['response']['data']);
        });
      }

      events.emit('error', error['response']);

      if (status === 400) {
        return Promise.reject(new BadRequestError(data['error']));
      }
      else if (status === 401) {
        dispatch({ type: 'redirect', payload: null });
        return Promise.reject(new UnauthorizedError(data['error']));
      }
      else if (status === 404) {
        return Promise.reject(new NotfoundError(data['error']));
      }
      else if (status === 417) {
        return Promise.reject(new ValidationError(data['error']));
      }
      else if (status === 418) {
        return  Promise.reject(new NotfoundError({ code: 'Код ошибки: 418', message: 'Ошибка при валидации WAF'}));
      }
      else if (status === 423) {
        return Promise.reject(new LockedError(data['error']));
      }
      else {
        return Promise.reject(new NetworkError(data['error']));
      }
    }
    else {
      events.emit('error', error);
      throw new NetworkError({ code: '1.1.0', message: 'Сервис временно не доступен' });
    }
  }
};

export default request;

export function createCancelToken() {
  return axios.CancelToken.source();
}
